// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter.session.properties = {
        ...props.apiParameter.session.properties,
        ...(props.parameter as any).properties,
    };
};

export const XngLoadCart: typeof LoadCart = async props => {
    const state = props.getState();
    const pageType = getCurrentPage(state).type;

    const cartId =
        pageType === "CheckoutShippingPage"
            ? state.pages.checkoutShipping.cartId
            : pageType === "OnePageCheckoutPage"
            ? state.pages.onePageCheckout.cartId
            : undefined;

    if (cartId) {
        props.dispatch(await loadCart({ cartId } as any));
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainAfter(chain, LoadCart, XngLoadCart);
